import React from "react";
import { Switch } from "./Switch";

type SwitchBrickProps = {
  checked: boolean | null;
  onChange: (checked: boolean) => void;
  title: React.ReactNode;
  description: string;
  disabled?: boolean;
};

export const SwitchBrick = ({
  checked,
  onChange,
  title,
  description,
  disabled = false,
}: SwitchBrickProps) => {
  return (
    <div
      onClick={() => onChange(!checked)}
      className="text-h3 cursor-pointer text-shadow_50 font-normal bg-white items-center p-3 rounded-xl shadow-sm border-1 flex flex-row gap-4"
    >
      <div className="flex flex-col gap-1">
        <div className="font-medium text-black">{title}</div>
        <div className="text-shadow_50">{description}</div>
      </div>
      <div className="flex flex-col ml-auto" onClick={(e) => e.stopPropagation()}>
        <Switch
          size="default"
          disabled={disabled}
          checked={checked}
          onChange={onChange}
        />
      </div>
    </div>
  );
};
